<template>
  <div class="graph-legend">
    <GraphLegendPercentage
      :value="legend.percentage"
      :color="legend.color"
    />
    <GraphLegendLabel :label="legend.label" />
  </div>
</template>

<script>
import GraphLegendLabel from './graph-legend-label.vue'
import GraphLegendPercentage from './graph-legend-percentage.vue'

export default {
  name: 'GraphLegend',

  components: {
    GraphLegendLabel,
    GraphLegendPercentage
  },

  props: {
    legend: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.graph-legend {
  display: flex;
  align-items: center;
  gap: 12px;
}
</style>
